/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* Add a class if the header menu has the text "セール" */
document.addEventListener('DOMContentLoaded', function() {
  // 指定したクラスの要素をすべて取得
  let elements = document.querySelectorAll('.header__linklist-link, button.mobile-nav__link');

  // 取得した各要素に対してループ処理
  elements.forEach(function(element) {
    // 要素のテキストに「セール」という文字列が含まれているかチェック
    if (element.textContent.includes('セール')) {
      // 「セール」という文字列が含まれていた場合、その要素に「sale」クラスを追加
      element.classList.add('sale');
    }
  });

  // show modal newletter Klaviyo
  // const ElementModalKlaviyo = document.getElementById('js-showModalKlaviyo');
  // ElementModalKlaviyo.addEventListener('click', function() {
  //   window._klOnsite = window._klOnsite || [];
  //   window._klOnsite.push(['openForm', 'Rfpjbf']);
  // });
  
  // countdown
  if (document.querySelectorAll('.c-countdown').length > 0) {
    const coutDownElement = document.getElementById('js-showcountdown');
    const idValue = coutDownElement.getAttribute('data-date');
    
    const targetDate = new Date(idValue).getTime();
  
    const countdown = setInterval(function() {
      const now = new Date().getTime();
      const timeRemaining = targetDate - now;
    
      if (timeRemaining <= 0) {
        clearInterval(countdown); 
      } else {
        const days = String(Math.floor(timeRemaining / (1000 * 60 * 60 * 24))).padStart(2, '0');
        const hours = String(Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0');
        const minutes = String(Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
        const seconds = String(Math.floor((timeRemaining % (1000 * 60)) / 1000)).padStart(2, '0');
    
        document.getElementById('days').innerHTML = `${days}`;
        document.getElementById('hours').innerHTML = `${hours}`;
        document.getElementById('mins').innerHTML = `${minutes}`;
        document.getElementById('secs').innerHTML = `${seconds}`;
      }
    }, 500);
  }

  if (document.querySelector('.product-form') != null) {
    const checkExitplSwatches = setInterval(function() {
        const $item = document.querySelector('.product-form .pl-swatches .pl-swatches__group');
        if (!$item) {
          clearInterval(checkExitplSwatches);
          document.querySelector('.product-form .product-form__option-selector[data-selector-type="color"]').style.display = "block";
        }
    }, 100); // check every 100ms
  }

  if (document.querySelector('.template-product .product__media-item .video-wrapper') != null) {
    setTimeout(function() {
        var mainImageHeight = document.querySelector(".flickity-viewport .product__media-item").clientHeight;
        document.querySelector(".flickity-viewport .product__media-item .video-wrapper").style.height = mainImageHeight + "px";
    }, 2000);
  
    window.addEventListener("resize", function() {
        var mainImageHeight = document.querySelector(".flickity-viewport .product__media-item").clientHeight;
        document.querySelector(".flickity-viewport .product__media-item .video-wrapper").style.height = mainImageHeight + "px";
    });
  }

  if (document.querySelector('.product-tabs') != null) {
    const checkExitJdgm = setInterval(function() {
        const $item = document.querySelector('.jdgm-row-actions .jdgm-sort-dropdown');
        if ($item) {
          clearInterval(checkExitJdgm);
          const element1 = document.querySelector(".jdgm-row-actions .jdgm-sort-dropdown option[value='lowest-rating']");
          const element2 = document.querySelector(".jdgm-row-actions .jdgm-sort-dropdown option[value='pictures-first']")
          const element3 = document.querySelector(".jdgm-row-actions .jdgm-sort-dropdown option[value='videos-first']");
          const element4 = document.querySelector(".jdgm-row-actions .jdgm-sort-dropdown option[value='with-pictures']");
          if (element1 || element2 || element3 || element4) {
            element1.remove();
            element2.remove();
            element3.remove();
            element4.remove();
          }
        }
    }, 100); // check every 100ms
  }

  // FAQ page
  $(".faq-block__question").click(function (e) {
      e.stopPropagation(); 
      const parentItem = $(this).closest(".faq-block__qna_item"); 
      parentItem.toggleClass("is-open"); 
      parentItem.find(".faq-block__answerWrap").stop().slideToggle(); 
  });

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener("click", function(e) {
          e.preventDefault(); 
  
          const targetId = this.getAttribute("href").substring(1);
          const targetElement = document.getElementById(targetId);
  
          if (targetElement) {
              const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - 80;
              window.scrollTo({
                  top: offsetTop,
                  behavior: "smooth"
              });
          }
      });
  });


  //SizeGuide page
  $(".size-guide__titleWrap").click(function (e) {
      e.stopPropagation(); 
      const parentItem = $(this).closest(".size-guide__item"); 
      parentItem.toggleClass("is-open"); 
      parentItem.find(".size-guide__content").stop().slideToggle(); 

      const lastSizeGuideItem = $(".size-guide__item").last();
      if (lastSizeGuideItem.is(parentItem) && lastSizeGuideItem.hasClass("is-open")) {
        $(".size-guide-moreinfo").css("margin-top", "unset");
      } else {
        $(".size-guide-moreinfo").css("margin-top", "");
      }
  });
});

var arrAppBlock = document.querySelectorAll('.shopify-section--apps .shopify-app-block');
if(arrAppBlock.length > 0){
  console.log(arrAppBlock);
  var checkIssetBlockInstaFeed = false;
  arrAppBlock.forEach(block => {
      if (block.id.includes('instafeed')) {
        checkIssetBlockInstaFeed = true;
      }
  });
  if(checkIssetBlockInstaFeed){
    var intervalInstaFeed = setInterval(sliderInstaFeed, 500);
    function sliderInstaFeed(){
      let instaFeedItem = document.querySelectorAll('#insta-feed .instafeed-container');
      if(instaFeedItem.length > 0){
        clearInterval(intervalInstaFeed);

        $('#insta-feed > div').slick({
         slidesToShow: 4,
         infinite:false,
         slidesToScroll: 1
        });
    
        if(!document.querySelector('.c-instafeed__bottom')){
          let newElement = document.createElement('div');
          newElement.className = 'c-instafeed__bottom';
          newElement.innerHTML = '<p>3つのハッシュタグをつけて投稿しよう！<br class="hidden-lap-and-up">#HunterBoots #StyledInHunter #Hunterスタイル</p><p>公式アカウント@hunterbootsjp をタグづけして投稿すると、当社オンラインサイトへの掲載に同意いただいたものとさせていただきます。</p><a target="_blank" href="https://www.instagram.com/hunterbootsjp/" class="c-instafeed__follow">Follow Us</a>';
          let instafeed = document.querySelector('#insta-feed');
          instafeed.parentNode.insertBefore(newElement, instafeed.nextSibling);
        }
      }
    }
  } 
}

if(document.querySelector('.template-product')){
  var intervalJudge = setInterval(addTextForAppJudge, 500);
  function addTextForAppJudge(){
    let judgeStars = document.querySelector('.jdgm-row-stars');

    if(judgeStars){
      clearInterval(intervalJudge);

      let newElement = document.createElement('div');
      newElement.className = 'c-judge__desc';
      newElement.innerHTML = '<strong>レビュー投稿でクーポンプレゼント！</strong><p>※商品配送や不良品などレビュー以外については<a href="/pages/contact">お問い合わせフォーム</a>よりご連絡ください。</p><p>※レビューを投稿することで、当社の<a href="/pages/ご利用規約">ご利用規約</a>に同意することになります。</p><p>※その他詳細は<a href="/pages/judege-me">レビュー投稿</a>についてをご確認ください。</p>';
      let judgeSummary = document.querySelector('.jdgm-widget-actions-wrapper');
      judgeSummary.parentNode.insertBefore(newElement, judgeSummary.nextSibling);       
      
    }
  }
}